/* Universal scroll-reveal utility.
 *
 * Opt-in via data-nb-reveal on any element. Default behaviour: when
 * the element enters the viewport, add the .nb-revealed class which
 * triggers a CSS opacity + translateY transition. Children with
 * data-nb-reveal-child can specify a delay via --nb-delay.
 *
 * Respects prefers-reduced-motion (skips the build, just shows). */
(function () {
  'use strict';

  function reveal(el) {
    if (el.dataset.nbRevealed === 'true') return;
    el.dataset.nbRevealed = 'true';
    el.classList.add('nb-revealed');
  }

  function init() {
    const els = document.querySelectorAll('[data-nb-reveal]');
    if (!els.length) return;

    const reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    els.forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
